const videoIDRegex = /(youtube\.com\/watch\?v=|youtu\.be\/)([0-9A-Za-z_-]{10}[048AEIMQUYcgkosw])/;

export const useYoutubeVideoID = (url: string): string | undefined => {
  if (typeof url !== 'string') {
    return undefined;
  }

  const match = url.match(videoIDRegex);
  return match?.[2];
};
